import "./Tabs.scss";
import { useState, useEffect } from "react";

function Tabs(props: any) {
  const tabs = [{ name: "Tất cả", _id: "" }, ...props.categories];

  const [activeTab, setActiveTab] = useState<number>(0);
  // const [nameActive, setNameActive] = useState<string>("");

  useEffect(() => {
    // Thay đổi vị trí của dấu gạch dưới khi tab được chọn
    const tabActive: HTMLElement | null =
      document.querySelector(".tab-item.active");
    const line: HTMLElement | null = document.querySelector(".tabs .line");

    if (tabActive && line) {
      line.style.left = tabActive.offsetLeft + "px";
      line.style.width = tabActive.offsetWidth + "px";
    }
  }, [activeTab]);

  const handleClickTab = (index: number, tab: any) => {
    // Xử lý khi tab được nhấp vào
    setActiveTab(index);
    props.setCategoryName(tab);
    props.setPage(1);
  };
  return (
    <div className="wrapper-tabs">
      <div className="tabs">
        {tabs.map((tab: any, index: number) => (
          <div
            key={index}
            className={`tab-item ${index === activeTab ? "active" : ""}`}
            onClick={() => handleClickTab(index, tab)}>
            {tab.name}
          </div>
        ))}
        <div className="line"></div>
      </div>
    </div>
  );
}

export default Tabs;
